import type {
  CreateProofShareRequest,
  CreateProofShareResponse,
  ProofShareableProduct,
  ProofShareValidation,
} from '@messenger/types'
import axios from '@/api/axios.config'

export const getShareableProofProducts = async (
  orderId: string,
  applicationType: 'MDL' | 'M3',
) => {
  return await axios.get<{ products: ProofShareableProduct[] }>(
    `proof-share/products/${orderId}?applicationType=${applicationType}`,
  )
}

export const createProofShare = async (payload: CreateProofShareRequest) => {
  return await axios.post<CreateProofShareResponse>('proof-share', payload)
}

// Public: the recipient of a shared proof link is unauthenticated.
export const getProofShareByToken = async (token: string) => {
  return await axios.get<ProofShareValidation>(`proof-share/token/${token}`)
}

export type ProofShareVersion =
  | { valid: true; fingerprint: string }
  | { valid: false }

// Public + cheap: the gallery polls this to detect a newer proof version and
// offer a refresh.
export const getProofShareVersion = async (token: string) => {
  return await axios.get<ProofShareVersion>(
    `proof-share/token/${token}/version`,
  )
}
